import { useContext } from 'react'
import { isFlashHotelType } from 'lib/offer/offerTypes'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { PRODUCT_TYPE_LIMITED_TIME_SPECIAL } from 'constants/offer'
import { isStandardOccupancy } from 'lib/search/searchUtils'

export function useHideAnytimePrices(
  offerType?: App.OfferType,
  metadataHidePricing?: boolean,
  productType?: App.ProductType,
  filters?: App.OfferListFilters,
): boolean {
  const globalSearchState = useContext(GlobalSearchStateContext)

  if (metadataHidePricing) {
    return true
  }

  const isLtsWithStandardOccupancy = productType === PRODUCT_TYPE_LIMITED_TIME_SPECIAL &&
    isStandardOccupancy(filters)

  return !!(globalSearchState?.hideAnytimePrices && !isFlashHotelType(offerType) && !isLtsWithStandardOccupancy)
}

export default useHideAnytimePrices
